import { useEffect, useState } from "react";
import SVG from "../../../Components/SVG"

const persianDigits = ["۰","۱","۲","۳","۴","۵","۶","۷","۸","۹"];

function toPersianDigits(str) {
  return str.replace(/\d/g, (d) => persianDigits[d]);
}

function getRemainingToday() {
  const now = new Date();
  const endOfDay = new Date();
  endOfDay.setHours(23, 59, 59, 999);

  let diff = endOfDay.getTime() - now.getTime();
  if (diff < 0) diff = 0;

  const totalSeconds = Math.floor(diff / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const seconds = String(totalSeconds % 60).padStart(2, "0");

  const time = `${hours}:${minutes}:${seconds}`;
  return toPersianDigits(time);
}

export default function Clock() {
  const [remaining, setRemaining] = useState(getRemainingToday());

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(getRemainingToday());
    }, 1000);

    return () => clearInterval(id);
  }, []);

  return (
    <div className="p-2.5 flex flex-col justify-center items-center gap-1 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <p className="text-sm font-normal text-zi-text-light/50 dark:text-zi-text-dark/50">
        به‌روزرسانی حد زیان مجاز روزانه در
      </p>
      <div className="flex justify-center items-center gap-2.5">
        <span className="text-2xl font-bold text-zi-text-light dark:text-zi-text-dark">
          {remaining}
        </span>
        <SVG
          name="clock"
          classname="size-5 stroke-zi-text-light dark:stroke-zi-text-dark"
        />
      </div>
    </div>
  );
}